const fetchCore = async (instance) => {
  const response = await instance.get("/api");
  return response.data;
};
const fetchNotifications = async (instance) => {
  const response = await instance.get("/api/notification");
  return response.data;
};
const fetchMenu = async (instance) => {
  const response = await instance.get("/api/menu");
  return response.data;
};
const fetchUser = async (instance) => {
  const response = await instance.get("/api/user/me");
  return response.data;
};

export { fetchCore, fetchMenu, fetchNotifications, fetchUser };
